export const templates = (state) => state.templates
export const totalCommunications = (state) => state.totalCommunications
export const selectAllField = (state) => state.selectAllField
export const selectedCommunications = (state) => state.selectedCommunications
